var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUnlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_unlocked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_unlocked",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#005082",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(6.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1.99 C1,1.443 1.443,1 1.99,1 L2.01,1 C2.557,1 3,1.443 3,1.99 L3,3 L4,3 L4,1.98 C4,0.886 3.114,0 2.02,0 L1.98,0 C0.886,0 4.4408921e-16,0.886 4.4408921e-16,1.98 L4.4408921e-16,3 L1,3 L1,1.99 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 3,
    y: 2,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,7.00104344 C2,7.55275191 2.45097518,8 2.99077797,8 L7.00922203,8 C7.55641359,8 8,7.55733967 8,7.00104344 L8,5 C8,4.448 7.552,4 7,4 L6,4 L4,4 L3,4 C2.448,4 2,4.448 2,5 L2,7.00104344 Z",
    id: "Fill-6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlocked);
export default __webpack_public_path__ + "static/media/icon_unlocked.a9cc24d33c46d1d73e5b57f515780fcc.svg";
export { ForwardRef as ReactComponent };